import React, { Component } from 'react';
import './index.scss';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {Cart, ProductType} from '../../store/ducks/cart/types';
import * as CartActions from '../../store/ducks/cart/actions';
import {Param} from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import Api from '../../services/api';
import {Diversos} from '../../services/diversos';
import InputMask from 'react-input-mask'

import Lottie from 'react-lottie';
import Loading from '../../assets/animations/domakoski-loading.json'

// import de Componentes
import Header from '../../components/Header';
import Footer from '../../components/Footer';

// import de Imagens/SVG
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import image1 from '../../assets/Images/image-1.png'
import image2 from '../../assets/Images/image-2.png'
import image3 from '../../assets/Images/image-3.png'



// import de Componentes do Bootstrap
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Modal from 'react-bootstrap/Modal'
import Carousel from 'react-bootstrap/Carousel'
import Dropdown from 'react-bootstrap/Dropdown'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Badge from 'react-bootstrap/Badge'
import Container from 'react-bootstrap/Container'


interface StateProps { 
  cart?: Cart;
  param: Param;
} 

interface DispatchProps {
  add(cart: ProductType): void;
  update(cart: ProductType): void;
  drop(rowid: string): void;
  setParam(data: Param): void;
}

// const DERIVATION_1 = [
//   "P",
//   "M",
//   "G",
//   "GG",
// ];

// const DERIVATION_2 = [
//   {
//     src: require('../../assets/Images/image-1.png'),
//     selectTitle: 'Carne 1',
//   },
//   {
//     src: require('../../assets/Images/image-2.png'),
//     selectTitle: 'Carne 2',
//   },
//   {
//     src: require('../../assets/Images/image-3.png'),
//     selectTitle: 'Carne 3',
//   },
// ];

// interface OwnProps {
//   imageOver: any,
//   imageNormal: any,
// } 

type Props = StateProps & DispatchProps;

// class SelectDerivation extends Component<Props> {
//   return (

//   );
// }

function SelectDerivation (this: any, props) {

  return (
    <div className="select-container">
      <div className="select-img-wrapper">
        <img src={props.src} alt="thumbnail do produto"/>
      </div>
      <p> {props.selectTitle} </p>
      {
        props.defaultActive &&
        (props.isOpen ? <FontAwesomeIcon icon={faChevronUp}/> : <FontAwesomeIcon icon={faChevronDown}/>)
      }
    </div>
  );
}



class Produto extends Component<Props> {

  api: any = null;
  state: any = null;
  static: any

  constructor (props) {
    super(props);
    
    this.api = new Api();
    
    const {nome} = props.match.params;

    this.state = {
      paramNome: nome,
      isLoading: true,
      produto: false,
      quantity: 1,
      firstDerivation: "",
      secondDerivation: false,
      activeSelect: {
        src: require("../../assets/Images/image-1.png"),
        selectTitle: "Verde",
      },

      activeIndex: 0,

      menu1: null,
      menu2: null,
      menu3: null,
      estoqueModal: null,

      freteCep: null,
      freteModal: null,
      freteHasError: null,
      freteHasErrorMsg: null,
      freteData: null,
      freteIsLoading: false,

      similarIsLoading: true,
      similarData: null,
      similarHasError: false,
      similarHasErrorMsg: null,

      derivation2: []
    }
  }

  async componentDidMount () {
    const self = this;

    if ( !self.state.paramNome ) {
      window.location.href = "/404";
      return;
    }

    self.setState({isLoading: true});

    try {
      const {data} = await self.api.get(`/product/${self.state.paramNome}/filter/name`);

      if ( !data.status ) {
        throw new Error('Produto não localizado');
      } else {
        self.setState({produto: data.msg});
        
        if (( data.msg.COMPLEMENTO ) && ( data.msg.COMPLEMENTO.MENU1 )) {
          const response = await self.api.get(`/menu/nivel1/${data.msg.COMPLEMENTO.MENU1}`);

          if ( response.data.status === true ) {
            self.setState({menu1: response.data.msg});
            self.getSimilares();
          }
        }

        if (( data.msg.COMPLEMENTO ) && ( data.msg.COMPLEMENTO.MENU2 )) {
          const response2 = await self.api.get(`/menu/nivel1/${data.msg.COMPLEMENTO.MENU2}`);

          if ( response2.data.status === true )
            self.setState({menu2: response2.data.msg});
        }

        if (( data.msg.COMPLEMENTO ) && ( data.msg.COMPLEMENTO.MENU3 )) {
          const response3 = await self.api.get(`/menu/nivel1/${data.msg.COMPLEMENTO.MENU3}`);

          if ( response3.data.status === true )
            self.setState({menu3: response3.data.msg});
        }

        let aux: any = [];

        if ( data.msg.COMPLEMENTO.CARACTERISTICA1 ) {
          aux.push({
            src: require('../../assets/Images/image-3.png'),
            selectTitle: data.msg.COMPLEMENTO.CARACTERISTICA1,
          });
        }

        if ( data.msg.COMPLEMENTO.CARACTERISTICA2 ) {
          aux.push({
            src: require('../../assets/Images/image-3.png'),
            selectTitle: data.msg.COMPLEMENTO.CARACTERISTICA2,
          });
        }

        if ( data.msg.COMPLEMENTO.CARACTERISTICA3 ) {
          aux.push({
            src: require('../../assets/Images/image-3.png'),
            selectTitle: data.msg.COMPLEMENTO.CARACTERISTICA3,
          });
        }

        if ( data.msg.COMPLEMENTO.CARACTERISTICA4 ) {
          aux.push({
            src: require('../../assets/Images/image-3.png'),
            selectTitle: data.msg.COMPLEMENTO.CARACTERISTICA4,
          });
        }

        if ( data.msg.COMPLEMENTO.CARACTERISTICA5 ) {
          aux.push({
            src: require('../../assets/Images/image-3.png'),
            selectTitle: data.msg.COMPLEMENTO.CARACTERISTICA5,
          });
        }

        if ( data.msg.COMPLEMENTO.CARACTERISTICA6 ) {
          aux.push({
            src: require('../../assets/Images/image-3.png'),
            selectTitle: data.msg.COMPLEMENTO.CARACTERISTICA6,
          });
        }

        self.setState({ 
          derivation2: aux,
          activeSelect: {
            src: aux[0].src,
            selectTitle: aux[0].selectTitle,
          }
        });
      }

    } catch (e) {
      console.error(e);
      window.location.href = "/404";
    } finally {
      self.setState({isLoading: false});
    }
  }

  private async getShippingModes () {
    const self = this;

    self.setState({freteIsLoading: true});

    try {
      let param = {cep: self.state.freteCep};
      const {data} = await self.api.post(`/shipping/modes`, param);

      if ( data.status === false ) {
        throw new Error('Não foi possível buscar opções de entrega.');
      } else {
        self.setState({freteData: data.msg});
      }

    } catch (e) {
      console.error(e);

      self.setState({
        freteData: null,
        fretehasError: true,
        freteHasErrorMsg: e.message
      });

    } finally {
      self.setState({freteIsLoading: false});
    }
  }

  private async getSimilares () {
    const self = this;

    self.setState({similarIsLoading: true});

    try {
      let param = {menu1: self.state.menu1.CDMENU};
      const {data} = await self.api.post(`/product/departamento`, param);

      if ( data.status === false ) {
        throw new Error('Não foi possível buscar produtos similares.');
      } else {
        self.setState({similarData: data.msg.data});
      }

    } catch (e) {
      console.error(e);

      self.setState({
        similarData: null,
        similarhasError: true,
        similarHasErrorMsg: e.message
      });

    } finally {
      self.setState({similarIsLoading: false});
    }
  }

  private async handleSimularFrete () {
    const self = this;
    self.setState({
      freteModal: true,
      freteIsLoading: true,
    });
    self.getShippingModes();
  }

  private async handleAddCart (event) {
    const self = this;
    event.preventDefault();

    if (this.state.quantity <= 0) {
      return window.alert("Selecione ao menos 1 item para concluir a compra");
    }

    else {
      // if (self.state.produto.CODIGO )
      self.props.add({
        codigo: self.state.produto.CODIGO,
        nome: self.state.produto.NOME,
        price: self.state.produto.PRECO,
        qty: this.state.quantity
      });
      self.props.setParam({ ...self.props.param, cartOpened: true });
    }
  }

  private IncreaseItem = () => {
    this.setState(prevState => {
      if (this.state.quantity < 9999) {
        return {
          quantity: this.state.quantity + 1
        }
      }

      else {
        return null;
      }
    });
  }

  private DecreaseItem = () => {
    this.setState(prevState => {
      if (this.state.quantity > 0) {
        return {
          quantity: this.state.quantity - 1
        }
      }

      else {
        return null;
      }
    });
  }

  handleChange = (event) => {
    this.setState({quantity: event.target.value});
  }

  private handleFirstDerivation = ev => {

    if (this.state.firstDerivation === (ev)) {
      this.setState({
        firstDerivation: "P"
      })
    }

    else {
      this.setState({firstDerivation: ev});
    }
  }

  private handleDerivationSelect (obj: any) {
    this.setState({
      activeSelect: {
        ...obj,
        src: obj.src,
        selectTitle: obj.selectTitle,
      },
    });
  }

  goToIndex(newIndex) {
    // if (this.animating) return;
    return this.setState({ activeIndex: newIndex });
  }


  render () {
    
    const isMobile = window.innerWidth < 576;
    const lottieSize = isMobile ? 290 : 350;

    return (
      <>
        <Header/>
          {
            (this.state.isLoading) ? 
            <>
              <section className="loading-screen-overlapped"/>
              <Modal
              show="true"
              // onHide={() => this..setParam({ ...this.props.param, cartOpened: false })}
              dialogClassName="loading-screen"
              className="px-0 loading-modal-container"
              aria-labelledby="Loading-screen">
                <Lottie 
                  options={{
                    loop: true,
                    autoplay: true, 
                    animationData: Loading,
                  }}
                  height={lottieSize}
                  width={lottieSize}
                  isStopped={false}
                  isPaused={false}
                />
              </Modal>
            </>
            :
            <>
              <section className="product-section">
                <Row className="breadcrumb-container">
                  <Breadcrumb>
                    <Breadcrumb.Item href="#"> Home </Breadcrumb.Item>
                    <Breadcrumb.Item href="#"> Categorias </Breadcrumb.Item>
                    {
                      this.state.menu1 && this.state.menu1.DESCRICAO &&
                      <Breadcrumb.Item active> {this.state.menu1.DESCRICAO} </Breadcrumb.Item>
                    }
                    {
                      this.state.menu2 && this.state.menu2.DESCRICAO &&
                      <Breadcrumb.Item active> {this.state.menu2.DESCRICAO} </Breadcrumb.Item>
                    }
                    {
                      this.state.menu3 && this.state.menu3.DESCRICAO &&
                      <Breadcrumb.Item active> {this.state.menu3.DESCRICAO} </Breadcrumb.Item>
                    }
                  </Breadcrumb>
                </Row>
                <Row className="pt-2 product-info-container">
                  <Col lg={6} className="image-tag">
                    {/* <Image src={croche} rounded fluid /> */}
                    <Carousel interval={null} indicators={false} controls={true} activeIndex={this.state.activeIndex} defaultActiveIndex={0}>
                      {/* <Carousel.Item>
                        <img
                          className="d-block w-100"
                          // src={`${process.env.REACT_APP_BASE_URL_PICTURE}/${Diversos.toSeoUrl(this.state.produto.NOME)}-1.png`}
                          src={image1}
                          alt="Primeira imagem do Produto"
                        />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          // src={`${process.env.REACT_APP_BASE_URL_PICTURE}/${Diversos.toSeoUrl(this.state.produto.NOME)}-1.png`}
                          src={image2}
                          alt="Segunda imagem do Produto"
                        />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          // src={`${process.env.REACT_APP_BASE_URL_PICTURE}/${Diversos.toSeoUrl(this.state.produto.NOME)}-1.png`}
                          src={image3}
                          alt="Terceira imagem do Produto"
                        />
                      </Carousel.Item> */}
                      {
                        ((this.state.produto.FOTOS) && (this.state.produto.FOTOS.length > 0)) ? 
                        this.state.produto.FOTOS.map((row, index) => (
                          <Carousel.Item key={index}>
                            <img
                              className="d-block w-100"
                              src={`${process.env.REACT_APP_BASE_URL_PICTURE}/${row.link}`}
                              alt={`${process.env.REACT_APP_BASE_URL_PICTURE}/${row.link}`}
                            />
                          </Carousel.Item>
                        ))
                        :
                        <Carousel.Item key={0}>
                          <img
                            className="d-block w-50 m-auto"
                            src={`${process.env.REACT_APP_BASE_URL_PICTURE}/produto-sem-imagem.png`}
                            alt={`${process.env.REACT_APP_BASE_URL_PICTURE}/produto-sem-imagem.png`}
                          />
                        </Carousel.Item>
                      }
                    </Carousel>
                    <ol className="carousel-indicators">
                    {
                      this.state.produto.FOTOS.map((row, index) => (
                        <li
                          key={index}
                          onClick={() => this.goToIndex(index)}
                          className={`carousel-indicator ${this.state.activeIndex === index ? "carousel-active" : ""}`}>
                          <img
                          className="d-block w-100 carousel-thumbnail"
                          src={`${process.env.REACT_APP_BASE_URL_PICTURE}/${row.link}`}
                          alt={`${process.env.REACT_APP_BASE_URL_PICTURE}/${row.link}`}
                          // src={image1}
                          />
                        </li>
                    ))}
                    </ol>
                  </Col>
                  <Col lg={6} className="product-tags">
                    <h1 className="name-tag"> {this.state.produto.NOME} </h1>
                    <p className="brand-tag" title="Marca do produto" aria-labelledby="Marca do produto"> {this.state.produto.MARCA} </p>
                    <Row>
                      <Col lg={6} xs={6}> 
                        <p> Código: <span> {this.state.produto.CODIGO} </span> </p>
                        {/* <p> Código: <strong> 22533 </strong> </p> */}
                      </Col>
                      <Col lg={6} xs={6}>
                        <p> Em estoque: <span> {this.state.produto.ESTOQUE} </span> </p>
                        {/* <p> Em estoque: <strong> 10 </strong> </p> */}
                      </Col>
                    </Row>
                    {/* <p> 1 uni. kit de agulhas de bambu para crochê </p> */}
                    {/* <p> 20 uni. agulhas de bambu </p> */}

                    {/* <h3 className="price-tag"> R$ {Diversos.number_format(this.state.produto.PRECO,2,",","")} </h3> */}
                    
                    {
                      ((this.state.produto.PREPRO) && (this.state.produto.PREPRO > 0) && (this.state.produto.PREPRO < this.state.produto.PRECO)) ? 
                      <>
                        <h6 className="discount-tag"> R$ {Diversos.number_format(this.state.produto.PRECO,2,",","")} </h6>
                        <span className="d-flex align-items-center price-container">
                          <h3 className="price-tag"> {Diversos.number_format(this.state.produto.PREPRO,2,",","")} </h3>
                          <Badge pill className="discount-badge"> 10 OFF </Badge>
                        </span>
                      </>
                      :
                      <span className="d-flex align-items-center price-container">
                        <h3 className="price-tag"> {Diversos.number_format(this.state.produto.PRECO,2,",","")} </h3>
                      </span>
                    }
                    

                    {/* <span className="d-block mt-3">
                      <small> Tamanho: <strong> {this.state.firstDerivation || "Selecione uma opção"} </strong> </small>
                      <ul className="simple-derivation">
                      {
                        DERIVATION_1.map(key => 
                          <li
                          key={key}
                          onClick={() => this.handleFirstDerivation(key)}
                          className={`simple-derivation-item ${key === this.state.firstDerivation ? "simple-derivation-item-active" : ""}`}>
                            {key}
                          </li>
                        )
                      }
                      </ul>
                    </span> */}
                    {
                      ((this.state.derivation2) && (this.state.derivation2.length > 0)) &&
                      <span className="d-block mt-3 select-derivation-container">
                        <small> Cortes: </small>
                        <Dropdown onClick={() => this.setState({secondDerivation: !this.state.secondDerivation})}>
                          <Dropdown.Toggle className="select-derivation" id="select-derivation">
                            <SelectDerivation {...this.state.activeSelect} defaultActive={true} isOpen={this.state.secondDerivation}/>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="select-derivation-dropdown">
                            {
                              this.state.derivation2.map(key =>
                                <Dropdown.Item href="#/action-1" className="select-derivation-item" onSelect={() => this.handleDerivationSelect(key)}>
                                  <SelectDerivation {...key} defaultActive={false} active={this.state.activeSelect === key}/>
                                </Dropdown.Item>
                              )
                            }
                          </Dropdown.Menu>
                        </Dropdown>
                      </span>
                    }
                    <Row className="mt-3">
                      <Col xs={12} sm={12} md={8} className="calc-frete-container">
                        <small> Simular frete </small>
                        <InputGroup className="calc-frete">
                          <InputMask mask="99.999-999" value={this.state.freteCep} onChange={(event) => this.setState({freteCep: Diversos.getnums(event.target.value)})}>
                            {(inputProps) => <Form.Control {...inputProps} type="tel" placeholder="00.000-000" className="text-center calc-frete-input" />}
                          </InputMask>
                          <InputGroup.Append>
                            <Button variant="primary" className="calc-frete-btn" disabled={!this.state.freteCep || this.state.freteCep.length < 8} onClick={this.handleSimularFrete.bind(this)}>
                              Calcular
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                    </Row>
                    
                    <Container className="mt-5">
                      <div className="amount-container">         
                        <button className="amount-btn" onClick={this.DecreaseItem}> - </button>
                        <input type="number"
                        className="amount-input"
                        // id={this.state.quantity > 99 ? "smaller-font" : ""}
                        name="quantidade"
                        value={this.state.quantity || ""}
                        onChange={this.handleChange}
                        min="1"
                        max="9999"
                        step="1"
                        defaultValue="1" />
                        <button className="amount-btn" onClick={this.IncreaseItem}> + </button>
                      </div>
                      <Row className="buy-container">
                        <Col lg={6} className="p-0">
                          <Button className="cart-primary-action buy-action" size="lg" onClick={this.handleAddCart.bind(this)}> Comprar </Button>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </section>
              <div className="product-details">
                <h2 className="details-heading"> Detalhes do produto </h2>
                <p>{this.state.produto.COMPLEMENTO.DESCRICAO1}</p>
                <p>{this.state.produto.COMPLEMENTO.DESCRICAO2}</p>
                <p>{this.state.produto.COMPLEMENTO.DESCRICAO3}</p>
              </div>
              <div className="similar-products">
                <h2 className="details-heading"> Produtos similares </h2>
                {/* Vitrine de produtos */}
              </div>
            </>
          }
          
        <Footer/>
      </>
    );


  }
  
}

const mapStateToProps = (state: ApplicationState) => ({
  cart: state.cart.data,
  param: state.param.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...CartActions, ...ParamActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Produto);